import axios from "axios"

const actionGetServiceReport = async ({commit}, payload) => {
  const service_reports = await axios.get(`${process.env.VUE_APP_URL_API}/v1/reports/services`, {params:{...payload}});
  commit("SET_SERVICES_REPORT", service_reports.data);
}

export default {
  actionGetServiceReport
}